import React, { useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Edit } from '@material-ui/icons';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/cercasVirtuais/actions';

import EditMap from './components/Edit';
import TopBar from './components/TopBar';

function CercasVirtuais() {
  const mapRef = useRef(null);
  const redux = useSelector((state) => state.cercasvirtuais);

  const header = useMemo(
    () => [
      {
        id: 'descricaocercavirtual',
        label: t('s.configuracao.cercavirtual.descricaocercavirtual'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const buttons = useMemo(
    () => [
      {
        title: t('s.geral.botaoalterar'),
        action: (value) => mapRef.current.handleToggleModal(value),
        icon: <Edit />,
      },
    ],
    []
  );

  // campos impressao pdf ou excel

  const fieldlist = ['descricaocercavirtual', 'itens'];

  const substituirHeader = {
    descricaocercavirtual: t(
      's.configuracao.cercavirtual.descricaocercavirtual'
    ),
    itens: t('s.configuracao.arqueacao.itens'),
  };

  return (
    <>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        actions={buttons}
        read={recordFiltering}
        find={findData}
        remove={deleteData}
        toolbar={TopBar}
        create={false}
        update={false}
        keys="idcercavirtual"
        detach="cercasVirtuais"
        excel
        pdf
        onExport={(formato) =>
          handleExportGeneric({
            endpoint: 'cercasvirtuais',
            formato,
            fields: fieldlist,
            redux,
            headers: substituirHeader,
            title: 'Relatório de Cercas Virtuais',
            ordination: redux.params.ordination,
            orderfield: redux.params.orderfield,
            ignorarFormatacao: { portaterminal: true },
          })
        }
      />

      <EditMap ref={mapRef} />
    </>
  );
}

export default CercasVirtuais;
